import api from "./api";

export function submitSupportTicket(params) {
    return api.post(`support/submit-ticket`, params);
}